<template>
	<KeyTakeaways v-if="keyTakeaways?.length > 0" :key-takeaways="keyTakeaways" />
	<RichTextComponent :blocks="bodyContent" :class="bodyContentClasses" />
</template>

<script setup lang="ts">
import KeyTakeaways from '@components/layout/key-takeaways.vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import { SanityKeyTakeaway } from 'types/sanity/education-center';
import { SanityRichTextBlock } from 'types/sanity';

interface Props {
	bodyContentClasses?: string;
	bodyContent: Array<SanityRichTextBlock>;
	keyTakeaways?: Array<SanityKeyTakeaway>;
}

withDefaults(defineProps<Props>(), {
	bodyContentClasses: 'wysiwyg-generated-content clearfix',
	keyTakeaways: () => []
});
</script>
